var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2048,
    height: 2048,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#545454}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_459777176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_459777752",
    d: "M1024 415.998c167.882 0 319.885 68.054 429.916 178.086 110.032 110.03 178.086 262.034 178.086 429.916s-68.054 319.885-178.086 429.916c-110.03 110.032-262.034 178.086-429.916 178.086s-319.885-68.054-429.916-178.086C484.052 1343.886 415.998 1191.882 415.998 1024s68.054-319.885 178.086-429.916C704.114 484.052 856.118 415.998 1024 415.998z",
    style: {
      fill: "#717171"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_459777584",
    className: "fil1",
    d: "M1235.44 261.96c31.424 8.701 61.864 19.195 91.195 31.357 29.683 12.306 58.631 26.485 86.708 42.396l19.47 11.035-3.124 22.041-21.797 153.755 136.665 136.665 136.335-32.082 24.23-5.701 12.065 21.919a786.096 786.096 0 0 1 39.406 82.611c11.295 27.738 21.146 56.642 29.445 86.603l5.965 21.53-17.934 13.48-124.032 93.23v193.44l118.995 73.66 21.236 13.146-6.95 23.922a784.744 784.744 0 0 1-30.598 86.18 788.048 788.048 0 0 1-40.432 82.192l-11.035 19.47-22.042-3.123-153.757-21.799-136.665 136.665 32.084 136.337 5.701 24.23-21.919 12.066a786.308 786.308 0 0 1-82.61 39.405c-27.74 11.294-56.642 21.144-86.604 29.445l-21.53 5.964-13.48-17.934-93.23-124.032H913.76l-73.66 118.995-13.147 21.238-23.921-6.95c-28.24-8.207-55.501-17.786-81.695-28.645a786.757 786.757 0 0 1-77.99-37.486l-21.92-12.063 5.703-24.232 32.084-136.337-136.665-136.665-153.757 21.798-22.04 3.124-11.037-19.47a787.91 787.91 0 0 1-40.43-82.184 785.21 785.21 0 0 1-30.6-86.19l-6.95-23.922 21.236-13.145 118.994-73.659V940.8L273.934 847.57l-17.93-13.478 5.96-21.531c8.293-29.949 18.138-58.837 29.43-86.566a787.385 787.385 0 0 1 39.423-82.649l12.064-21.919 24.232 5.702 136.335 32.082 136.665-136.665-21.798-153.755-3.124-22.04 19.47-11.037c26.297-14.907 53.719-28.415 82.15-40.413a786.192 786.192 0 0 1 86.224-30.618l23.92-6.954 13.148 21.24 73.658 118.994h193.44l93.232-124.032L1213.91 256l21.532 5.961zm-211.439 186.037c159.046 0 303.05 64.473 407.288 168.714 104.241 104.238 168.714 248.242 168.714 407.288 0 159.046-64.473 303.05-168.714 407.288-104.238 104.241-248.242 168.714-407.288 168.714-159.046 0-303.05-64.473-407.288-168.714-104.241-104.238-168.714-248.242-168.714-407.288 0-159.046 64.473-303.05 168.714-407.288 104.238-104.241 248.242-168.714 407.288-168.714z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_459777416",
    className: "fil1",
    d: "M1024 639.997c106.031 0 202.034 42.981 271.526 112.475 69.494 69.493 112.475 165.495 112.475 271.526s-42.981 202.034-112.475 271.526c-69.493 69.494-165.495 112.475-271.526 112.475s-202.034-42.981-271.526-112.475c-69.494-69.493-112.475-165.495-112.475-271.526s42.981-202.034 112.475-271.526C821.967 682.978 917.969 639.997 1024 639.997z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_459777248",
    d: "M1140.49 907.503c-29.811-29.811-70.999-48.25-116.496-48.25s-86.685 18.439-116.496 48.25c-29.811 29.811-48.25 70.999-48.25 116.496s18.439 86.685 48.25 116.496c29.811 29.811 70.999 48.25 116.496 48.25s86.685-18.439 116.496-48.25c29.811-29.811 48.25-70.998 48.25-116.496 0-45.497-18.439-86.685-48.25-116.496z",
    style: {
      fill: "#282929"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h2048v2048H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e52a9739b163278ebe589568ae4e38a6.svg";
export { ForwardRef as ReactComponent };